import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import {useAuthStore} from "@/store/AuthStore";

// Create the Vue application instance
const app = createApp(App);
app.use(router);
const pinia = createPinia();
app.use(pinia);
// Extract JWT from URL
const urlParams = new URLSearchParams(window.location.search);
const token = urlParams.get('token');

if (token) {
    const authStore = useAuthStore(); // Get the auth store instance
    authStore.setToken(token); // Store the JWT token
}
app.mount('#app'); // Mount the app to the DOM
